<template>
    <v-card>
        <v-card-title class="headline primary darken-1 white--text d-flex justify-space-between">
            {{ videoTitle }}
            <v-btn
                icon
                @click="closeVideo()">
                <v-icon 
                    class="white--text">
                    mdi-close
                </v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="py-6 align-center mx-auto">                    
            <div v-if="videoValid === null || videoValid === false">
                <v-progress-circular   
                    v-if="videoValid === null"
                    indeterminate
                    color="primary"
                    class="mx-auto my-12 py-12 d-block"
                    size="100"
                    width="5">
                </v-progress-circular>

                <div v-if="videoValid === false" class="d-block my-12 py-12 text-center sansation_title">
                    We're sorry, this video is not available at this time.
                </div>
            </div>

            <VideoPlayer v-if="videoValid"
                :key="videoUrl"
                :video_id="videoUrl"
                :video_src="videoSrc"
                :video_type="videoType" />
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "HandleVideo",

        components: {
            // VideoPlayer: () => import('@/components/shared/videoPlayer.vue')
        },

        props: {
            videoData: {
                type: Object,
                required: false,
            },
        },

        data () {
			return {
				videoUrl: '',
				videoSrc: '',
				videoType: '',
				videoTitle: 'Resource Video',
				videoValid: null,
            }
        },

        methods: {
            playResourceVideo: async function () {
				this.videoDialog = true
				this.videoUrl    = this.videoData.url
				// https://mycompass-production.s3.us-west-2.amazonaws.com/resource_files/Introduction%20Video.mp4?
				// X-Amz-Algorithm=AWS4-HMAC-SHA256&
				// X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&
				// X-Amz-Credential=AKIAXMOUSJ6P5QSDNUMA%2F20250723%2Fus-west-2%2Fs3%2Faws4_request&
				// X-Amz-Date=20250723T164445Z&
				// X-Amz-Expires=259200&
				// X-Amz-Signature=9939f9345861ac75ba6d5d847b9b8f75a0d14bf61ff5d9b03c05de4b9ff4e545&
				// X-Amz-SignedHeaders=host&
				// x-amz-checksum-mode=ENABLED&
				// x-id=GetObject
				this.videoValid = await this.videoValidation( this.videoUrl )

				if ( this.videoValid ) {
					this.videoId     = data.fileid
					this.videoSrc    = data.url.includes('vimeo') ? 'Vimeo' : 'AWS'
					this.videoTitle  = data.title
					this.videoType   = data.type
				}
			},

			videoValidation: async function ( videoUrl ) {
				try {
					if ( videoUrl.includes('vimeo') ) return true

					const video_params = new URLSearchParams(videoUrl.split('?')[1]);
					const signature = video_params.get('X-Amz-Signature') || video_params.get('Signature') || false // S3 OR CLOUDFRONT SIGNED URL
					const expires = video_params.get('X-Amz-Expires') || video_params.get('Expires') || false
					const today = Date.now()

					return signature && expires && today >= expires
				} catch (error) {
					// console.log('error', error.response)
					return false
				}
			},

			closeVideo: async function () {
				// Reset all video variables
				this.videoDialog    = null
				this.videoValid     = null
				this.videoId        = ''
				this.videoSrc       = ''
				this.videoUrl       = ''
				this.videoType      = ''
				this.videoTitle     = 'Resource Video'
			},
        }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/handleVideo.vue